 
// router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import Chat from '@/views/ChatView.vue'
import Login from '@/views/LoginView.vue'
import Menu from '@/views/MenuView.vue'
import OfflineGame from '@/views/OfflineGame.vue'
import Onboarding from '@/views/Onboarding.vue'
import Main from '@/views/MainPage.vue'
import Conversations from '@/views/ConversationsView.vue'
import imagegeneration from '@/views/ImageGenerationView.vue'
import styles from '@/views/StylesView.vue'
import ImagePreview from '@/views/ImagePreview.vue'
import ImageEditPreview from '@/views/ImageEditPreview.vue'
import CharactersPage from '@/views/CharactersPage.vue'
import GalleryView from '@/views/GalleryView.vue'
import CreatedImageView from '@/views/CreatedImageView.vue'
import CreatedEditImageView from '@/views/CreatedEditImageView.vue'
import PackagesView from '@/views/PackagesView.vue'
import ReferralView from '@/views/ReferralView.vue'
import ImageAnsweringView from '@/views/ImageAnsweringView.vue'
import PromotionView from '@/views/PromotionView.vue'
import EditImageView from '@/views/EditImageView.vue'
import VideoGenerationView from '@/views/VideoGenerationView.vue'
import ToolsView from '@/views/ToolsView.vue'
const routes = [
    {
        path: '/chat',
        name: 'Chat',
        component: Chat
    },
    
    {
        path: '/login',
        name: 'LoginView',
        component: Login
    },
    {
        path: '/menu',
        name:'Menu',
        component: Menu
    },
    {
        path: '/game',
        name:'Game',
        component: OfflineGame
    },
    {
        path: '/onboarding',
        name:'OnBoarding',
        component: Onboarding
    },
    {
        path: '/',
        name:'روبو',
        component: Main,
    },
    {
        path: '/conversations',
        name:'گفتگو ها',
        component: Conversations
    },
    {
        path: '/imagegeneration',
        name:'عکس',
        component: imagegeneration
    },
    {
        path: '/styles',
        name:'Styles',
        component: styles
    },
    {
        path: '/imagepreview',
        name:'ImagePreview',
        component: ImagePreview
    },
    {
        path: '/imageeditpreview',
        name:'ImageEditPreview',
        component: ImageEditPreview
    },
    {
        path: '/characters',
        name:'شخصیت ها',
        component: CharactersPage
    },
    {
        path: '/gallery',
        name:'گالری',
        component: GalleryView
    },
    {
        path: '/createdimage',
        name:'CreatedImage',
        component: CreatedImageView
    },
    {
        path: '/creatededitimage',
        name:'CreatedEditImage',
        component: CreatedEditImageView
    },
    {
        path: '/packages',
        name:'Packages',
        component: PackagesView
    },
    {
        path: '/referral',
        name:'Referral',
        component: ReferralView
    },
    {
        path: '/imageanswering',
        name:'imageanswering',
        component: ImageAnsweringView
    },
    {
        path: '/promotion',
        name:'promotion',
        component: PromotionView
    },
    {
        path: '/editimage',
        name:'editimage',
        component: EditImageView
    },
    {
        path: '/videogeneration',
        name:'ویدیو',
        component: VideoGenerationView
    },
    {
        path: '/tools',
        name:'ابزارها',
        component: ToolsView
    }

]
/* eslint-disable */
const router = createRouter({ history: createWebHistory(), routes, scrollBehavior (to, from, savedPosition) {
        if(!(from.path == "/imagepreview" && to.path == "/Gallery"))
        return {  top: 0,
            behavior: 'instant', }
            else
            console.log("Here");
  }})
export default router
// router.beforeEach(async (to, from) => {

router.beforeEach(async () => {

    var elements = document.getElementById("topnav");
      if(elements != null)
      {
            if(elements.style.backgroundColor == "rgb(97, 83, 204)")
            elements.style.backgroundColor='#212529';
      }
  });